import { render, staticRenderFns } from "./productFeatures.vue?vue&type=template&id=fe6f484e&scoped=true&"
import script from "./productFeatures.vue?vue&type=script&lang=js&"
export * from "./productFeatures.vue?vue&type=script&lang=js&"
import style0 from "./productFeatures.vue?vue&type=style&index=0&id=fe6f484e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6f484e",
  null
  
)

export default component.exports